import { importProvidersFrom } from '@angular/core';
import { Routes } from '@angular/router';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SmartRecoPatientEffects } from './store/effects/smart-reco-patient.effects';
import { SmartRecoStepsEffects } from './store/effects/smart-reco-steps.effects';
import { SmartRecoRecommendationEffects } from './store/effects/smart-reco-recommendation.effects';
import * as fromSmartReco from './store/smart-reco-reducers';
import { smartRecoFeatureKey } from './store/smart-reco-feature-key';

import { AppRoutes } from '@app/shared/utils/enums/routes.enum';

export const provideSmartRecoStore = () => [
  importProvidersFrom(
    // register feature reducer
    StoreModule.forFeature(smartRecoFeatureKey, fromSmartReco.reducers, {
      metaReducers: fromSmartReco.metaReducers,
    }),
    // run feature effects
    EffectsModule.forFeature([SmartRecoStepsEffects, SmartRecoPatientEffects, SmartRecoRecommendationEffects]),
  ),
];

export const routes: Routes = [
  { path: '', redirectTo: AppRoutes.PATIENT, pathMatch: 'full' },
  {
    path: AppRoutes.PATIENT,
    loadComponent: () =>
      import(`@app/pages/smart-reco/smart-reco-patient/smart-reco-patient.component`).then((c) => c.SmartRecoPatientComponent),
  },
  {
    path: AppRoutes.RECOMMENDATION,
    loadComponent: () =>
      import(`@app/pages/smart-reco/smart-reco-recommendation/smart-reco-recommendation.component`).then(
        (c) => c.SmartRecoRecommendationComponent,
      ),
  },
];
